export default __webpack_public_path__ + "static/media/youtube-videos-2023.887756f4.jpg";